<mm-table
    *ngIf="reasonList.length > 0"
    [values]="reasonList"
    [columnNames]="columnName"
    [tableSize]="scrollSize"
    [thClass]="['size',null,null]"
    [tdClass]="['asd',null,null]"
    (tdClick)="tableeditReason($event)">
</mm-table>
